<template>
  <ProgressSpinner />
</template>

<script setup>
import { computed, watch } from "vue";
import { useRoute } from "vue-router";
import { CURRENT_USER_EXTRACTED_PROPERTIES } from "../assets/constants";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

const route = useRoute();
const router = useRouter();
const magicLinkToken = computed(() => route.params.token);
const store = useStore();

watch(
  magicLinkToken,
  async (token) => {
    if (!token) {
      return;
    }

    const res = await fetch(
      process.env.VUE_APP_MP_SERVER_API_URL + "auth/login-with-magic-link",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ magic_link_key: token }),
      }
    );
    const response = await res.json();
    const data = response.data;

    if (response.status === "error") {
      router.push('/login/login')
      return
    } else if (data.accessToken) {
      localStorage.setItem("tokenMP", JSON.stringify(data));
    } else {
      console.log("server failed to return access token");
      router.push('/login/login')
      return
    }

    const currentUser = {
      uid: data.self.id,
      name: data.self.name.fullName,
      type: data.self.role,
      self: data.self,
      email: data.self.email,
      location: data.self.location,
    };

    const preparedUser = Object.fromEntries(
      Object.entries(currentUser).filter(([key]) =>
        CURRENT_USER_EXTRACTED_PROPERTIES.includes(key)
      )
    );

    store.commit("user/setCurrentUser", preparedUser);
    store.commit("user/cleanupStoredUsers");
    const storedUser = store.getters["user/storedUserByEmail"](data.self.email);
    localStorage.setItem("firstLogin", !storedUser);

    if (!storedUser) {
      store.commit("user/updateCurrentUser", { ...currentUser });
    } else {
      // Update users with updated fields
      storedUser.name = currentUser.name;
      storedUser.uid = currentUser.uid;
      storedUser.team = currentUser.team;
      storedUser.type = currentUser.type;
      storedUser.country = currentUser.country;
      storedUser.servicesProvided = currentUser.servicesProvided;
      storedUser.self = currentUser.self;
      store.commit("user/setCurrentUser", storedUser);
    }

    store.commit("user/updateStoredUsers", currentUser);
    router.push("/home");
  },
  { immediate: true }
);
</script>